import { yupResolver } from "@hookform/resolvers/yup";
import { ButtonSet, Form, Loading } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import BusinessIdeaForm from "../../components/Forms/BusinessIdeaForm";
import BusinessProfileForm from "../../components/Forms/BusinessProfileForm";
import CompetitorDataForm from "../../components/Forms/CompetitorDataForm";
import ExecutiveSummaryForm from "../../components/Forms/ExecutiveSummaryForm";
import Card from "../../components/Card/Card";
import {
  basicApplicationSchema,
  basicBusinessPlanSchema,
} from "../../services/SchemaService";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../http-common";
import {
  transformCheckboxArraysToBooleans,
  transformDropdownValues,
  transformBackendDataForForm,
} from "../../services/Utils";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import ApplicationFillingInstructions from "../../components/Miscellaneous/ApplicationFillingInstructions";
import BusinessPlanFillingInstructions from "../../components/Miscellaneous/BusinessPlanFillingInstructions";
import EnvironmentalSocialAnalysisForm from "../../components/Forms/EnvironmentalSocialAnalysisForm";
import FinancialPlanForm from "../../components/Forms/FinancialPlanForm";
import EmployeesForm from "../../components/Forms/WorkersForm";
import MarketAnalysisForm from "../../components/Forms/MarketAnalysisForm";
import ExistingBusinessProfileForm from "../../components/Forms/ExistingBusinessProfileForm";
import DataSheetForm from "../../components/Forms/DataSheetForm";
import WorkersForm from "../../components/Forms/WorkersForm";
import useBusinessPlan from "../../hooks/useBusinessPlan";

const UpdateBusinessPlanPage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { businessPlan, isLoading: businessPlanLoading } =
    useBusinessPlan(uuid);
  const [hasBusinessCurrently, setHasBusinessCurrently] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { user, isCompetitor } = useAuth();
  const [districts, setDistricts] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(basicBusinessPlanSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    console.log(data);
    try {
      // Transform checkbox arrays to boolean values and dropdown values before sending to backend
      let transformedData = transformCheckboxArraysToBooleans(data);
      transformedData = transformDropdownValues(transformedData);
      const response = await http.put(
        `/business-plan/${params.uuid}`,
        transformedData
      );
      toast.success("Plano de Negócio actualizado com sucesso");
      navigate("../plano-de-negocio/" + uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    if (
      !businessPlanLoading &&
      businessPlan &&
      Object.keys(businessPlan).length > 0
    ) {
      const formData = transformBackendDataForForm(businessPlan);
      reset(formData);
      setHasBusinessCurrently(businessPlan.hasBusinessCurrently);
      setTimeout(() => {
        setIsLoading(false);
      }, "2000");
    }
  }, [uuid, businessPlan, businessPlanLoading, reset]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Editar Plano de Negócio">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="INSTRUÇÕES">
            <BusinessPlanFillingInstructions />
            <div className="tab-navigation">
              <p></p>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-1" label="SECÇÃO 1">
            <DataSheetForm
              register={register}
              control={control}
              errors={errors}
              hasBusinessCurrently={hasBusinessCurrently}
              setHasBusinessCurrently={setHasBusinessCurrently}
              businessPlan={businessPlan}
              setValue={setValue}
              getValues={getValues}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-2" label="SECÇÃO 2">
            <ExistingBusinessProfileForm
              register={register}
              control={control}
              errors={errors}
              setHasBusinessCurrently={setHasBusinessCurrently}
              businessPlan={businessPlan}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="SECÇÃO 3">
            <MarketAnalysisForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 4">
            <WorkersForm
              register={register}
              errors={errors}
              control={control}
              getValues={getValues}
              businessPlan={businessPlan}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-5" label="SECÇÃO 5">
            <FinancialPlanForm
              register={register}
              control={control}
              errors={errors}
              businessPlan={businessPlan}
              getValues={getValues}
              setValue={setValue}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-6" label="SECÇÃO 6">
            <EnvironmentalSocialAnalysisForm
              businessPlan={businessPlan}
              register={register}
              errors={errors}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        <ButtonSet>
          <SubmitButton />
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default UpdateBusinessPlanPage;
